// extracted by mini-css-extract-plugin
export default {"dealModalInputWrapper":"styles_dealModalInputWrapper__DUP1J","dealModalInputWrapper__input":"styles_dealModalInputWrapper__input__NfqZ6"};